import { onlineManager, useSuspenseQueries } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { queryKeys } from '@/queries/keys'
import {
  getAdditionalPointsQueryOptions,
  getBookingQueryOptions,
  getBookingTransportationQueryOptions,
  getSpecialLocationsQueryOptions,
} from '@/queries/query'
import { PageWithRedirectSearchSchema } from '@/schemas/page'
import RoutesPage from '@/pages/make-booking/bus-details/Routes'

export const Route = createFileRoute(
  '/make-booking/$id/bus-details/$transportationId/routes/',
)({
  validateSearch: PageWithRedirectSearchSchema,
  loader: ({ context, params }) => {
    if (onlineManager.isOnline() && !context.isRestoring) {
      return [
        context.queryClient.ensureQueryData(
          getBookingTransportationQueryOptions(params.transportationId),
        ),
        context.queryClient.ensureQueryData(getAdditionalPointsQueryOptions()),
        context.queryClient.ensureQueryData(getSpecialLocationsQueryOptions()),
      ]
    }
    return [
      context.queryClient.getQueryData(
        queryKeys.booking.transportation(params.transportationId),
      ),
      context.queryClient.getQueryData(queryKeys.config.additionalPoints()),
      context.queryClient.getQueryData(queryKeys.config.specialLocations()),
    ]
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { id, transportationId } = Route.useParams()
  const [
    {
      data: {
        data: { booking },
      },
    },
    {
      data: {
        data: { booked_transportation: transportation },
      },
    },
  ] = useSuspenseQueries({
    queries: [
      getBookingQueryOptions(id),
      getBookingTransportationQueryOptions(transportationId),
    ],
  })

  return <RoutesPage booking={booking} transportation={transportation} />
}
